/*
 * @Description:
 * @Author: xiawenlong
 * @Date: 2021-03-22 19:09:20
 * @LastEditors: xiawenlong
 * @LastEditTime: 2021-12-04 17:07:52
 */
export default {
  myClass: '/course/identify/learncentre/myclass',
  productCategory: '/course/product-category/nav/tree',
  banner: '/course/adbanner/query/list',
  myCourseDetail: '/course/identify/learncentre/course/detail',
  videoPlayUrl: '/third/api/huaWeiUpload/getVideoInfo',
  videoPlayUrl_ksb: '/course/identify/ksb/course/query/CourseChapterLiveUrl',
  videoPlayUrl_ali: '/third/api/aliUpload/getVideoPlayUrl',
  recordUpdate: '/course/identify/learncentre/study/record/update',
  collection: '/course/identify/collection/query',
  freeCourse: '/course/product/free/list',
  classDetail: '/course/portal/class/detail',
  currentDuration: '/course/section/currentduration',
  recommond: '/course/product/courses/recommond',
  organizations: '/course/organizations',
  classList: '/course/organiztion/classes/list',
  cousreList: '/course/shop/courses/list',
  collegeDetail: '/course/organiztion/detail',
  collegeCourse: '/course/organiztion/detail/courses/list',
  collegeClass: '/course/organiztion/detail/classes/list',
  courseDetail: '/course/portal/course/detail',
  coursePlayDetail: '/course/product/course/play/detail',
  collegeTeacher: '/course/user/teacher/find/org/teachers',
  teacherInfo: '/course/user/teacher/findTeacherInfoByFaculty',
  teacherCourse: '/course/user/teacher/findTeacherCourseInfoByFaculty',
  videoCategory: '/course/user/category/query/short/video/tree',
  shortVideo: '/course/shortvideo/page',
  shortVideoLike: '/course/identify/shortvideo/like',
  shortVideoUnLike: '/course/identify/shortvideo/unlike',
  shortVideoRecord: '/course/shortvideo/study/record/update',
  orgvideo: '/course/shortvideo/orgvideo/page',
  orgvideoLastid: '/course/shortvideo/orgvideo/page/lastid',
  orgvideoSum: '/course/shortvideo/orgvideo/sum',
  studyHistory: '/course/identify/learncentre/play/history',
  shortVideoById: '/course/shortvideo/querybyid',
  shortVideoShare: '/course/shortvideo/share',
  shortVideoOpenShare: '/course/shortvideo/openShare',
  shortvideoLastid: '/course/shortvideo/page/lastid',
  mybuycourse: '/course/identify/learncentre/mybuycourse',
  addCollect: '/course/identify/collection/add',
  randShortvideoLastid: '/course/shortvideo/page/rand',
  liveOnlineUser: '/course/identify/learncentre/live/online/user',
  joinChat: '/course/userLive/addImRoom',
  searchUser: '/course/identify/im/user/query/by/imaccount',
  videoPlayInfo: '/course/video/play/info',
}
